export default __webpack_public_path__ + "static/media/usduzuz.37316351.png";